import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { ExtraFiltersModalContainer } from './modal/container';
import { ISavedFilters } from '../../../store/saved_filters';
import * as styles from './index.css';

export interface IExtraFiltersStoreProps {
  savedFilters: ISavedFilters;
}

export interface IExtraFiltersDispatchProps {
  saveLastFilters(): void;
  applyLastFilters(): void;
}

export interface IExtraFiltersState {
  isOpen: boolean;
}

type TProps = IExtraFiltersStoreProps & IExtraFiltersDispatchProps;

export class ExtraFilters extends React.Component<TProps, IExtraFiltersState> {
  public readonly state = {
    isOpen: false,
  };

  public render() {
    const { savedFilters } = this.props;

    return (
      <div className={styles['container']}>
        <Button size="XS" theme="stroke_secondary" type="button" onClick={this.toggleModal}>
          Ещё фильтры
        </Button>
        {!!savedFilters.items.length && <div className={styles['badge']} />}
        {this.state.isOpen && <ExtraFiltersModalContainer onClose={this.toggleModal} />}
      </div>
    );
  }

  private toggleModal = () => {
    this.setState(
      state => ({ isOpen: !state.isOpen }),
      () => {
        if (this.state.isOpen) {
          this.props.saveLastFilters();
        } else {
          this.props.applyLastFilters();
        }
      },
    );
  };
}
